import { getExamCoverage } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/variants/laboratory/_utils/get-exam-coverage.util';
import { SchedulesSearchProcedure, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { PartnerExamsCoverage } from '@/app/(main)/_components/search-modal/search-modal.types';
import { partnerBranchDisplayName } from '@/utils/formatters/branch';

export const buildExamsCoverage = (
  schedule: SearchPartnerData,
  proceduresResearchedLength: number,
): PartnerExamsCoverage => {
  const { total, isFullCoverage } = getExamCoverage(schedule.procedures, proceduresResearchedLength);

  return {
    partnerName: partnerBranchDisplayName(schedule.partner),
    isFullCoverage,
    total,
    offeredProcedures: schedule.procedures
      .filter((procedure): procedure is SchedulesSearchProcedure & { price: number } => procedure.price !== undefined)
      .map((procedure) => ({ id: procedure.id, name: procedure.name, price: procedure.price })),
    notOfferedProcedures: schedule.procedures
      .filter((procedure) => procedure.price === undefined)
      .map((procedure) => ({ id: procedure.id, name: procedure.name })),
  };
};
